import * as arSrcs from "url:../../models/*";
import * as classes from "./look-viewer.module.scss";
import content from "../../content.json";
import { useContext, FC } from "react";
import { ActionType, AppContext, World } from "../../contexts/AppContext";
import LookViewerItem from "./LookViewerItem";
import LookViewerCanvas from "./LookViewerCanvas";
import classNames from "classnames";
import ARQuickViewButton from "./ARQuickViewButton";
import Button from "../Button/Button";
import IconCL from "../../icons/IconCL.svg";
import IconFF from "../../icons/IconFF.svg";
import IconFT from "../../icons/IconFT.svg";
import Spinner from "../Spinner/Spinner";

const LookViewer: FC<{ name: string }> = ({ name }) => {
  const { state, dispatch } = useContext(AppContext);
  const { isViewerLoading } = state;
  const data = content.looks[name];
  const { name: displayName, items, world } = data;

  return (
    <div className={classNames(classes.root)}>
      <div className={classes.viewer}>
        <h2 style={{ opacity: 0, position: "absolute", pointerEvents: "none" }}>
          {displayName}
        </h2>
        <LookViewerCanvas name={name} />
        {isViewerLoading ? <Spinner className={classes.loading} /> : null}
        <Button
          className={classes.close}
          type="button"
          label="Close"
          onClick={() => {
            dispatch({ type: ActionType.SetModal, value: null });
          }}
        />
        <ARQuickViewButton
          src={arSrcs[`${content.looks[name].arGlb}.glb`]}
          iosSrc={arSrcs[`${content.looks[name].arUsdz}.usdz`]}
          title={content.looks[name].name}
        />
      </div>

      <div className={classes.items}>
        {Object.keys(items).map((key) => (
          <LookViewerItem {...items[key]} objectKey={key} key={key} />
        ))}
      </div>
    </div>
  );
};

export default LookViewer;
